import { Injectable } from '@angular/core';
import { AppSettings } from '../../../settings';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CostCenterSummary } from '../../admin-state/state.model';
import { AverageTrafficSummary } from '../../average-traffic/average-traffic.model';
import { Unpaid, UnpaidDetails } from '../../unpaid/unpaid.model';

@Injectable()
export class CostCenterService {

constructor(
    private httpClient: HttpClient,
    private appsettings: AppSettings
) { }

    httpGetCostCenters() {
        return this.httpClient.get<any[]>(this.appsettings.apiUrl + 'costcenters', {
            observe: 'body',
            responseType: 'json'
        }).map(
            (response) => {
                return response;
            });
    }

    httpGetUserCostCenters() {
      return this.httpClient.get<any[]>(this.appsettings.apiUrl + 'costcenters/GetUserCostCenters', {
          observe: 'body',
          responseType: 'json'
      }).map(
          (response) => {
            return response;
          });
  }

    httpGetZones() {
        return this.httpClient.get<any[]>(this.appsettings.apiUrl + 'costcenters/GetZones', {
            observe: 'body',
            responseType: 'json'
        }).map(
            (response) => {
                return response;
            });
    }

    httpGetGroups() {
      return this.httpClient.get<any[]>(this.appsettings.apiUrl + 'costcenters/GetGroups', {
          observe: 'body',
          responseType: 'json'
      }).map(
          (response) => {
            return response;
          });
    }

    httpGetSubCostCenters() {
        return this.httpClient.get<any[]>(this.appsettings.apiUrl + 'costcenters/GetSubCostCenters', {
            observe: 'body',
            responseType: 'json'
        }).map(
            (response) => {
                return response;
            });
    }

    httpGetCostCenterSummary(costCenterId: number) {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('CostCenterId', costCenterId.toString());

        return this.httpClient.get<CostCenterSummary>(this.appsettings.apiUrl + 'costcenters/CostCenterSummary', {
            observe: 'body',
            responseType: 'json',
            params: httpParams
        }).map(
            (response) => {
                return response;
            });
    }

    httpGetCostCentersState(zoneIds: number[]) {
        let httpParams = new HttpParams();
        zoneIds.forEach(zoneId => {
          httpParams = httpParams.append('ZoneIds', zoneId.toString());
        });

        return this.httpClient.get<CostCenterSummary[]>(this.appsettings.apiUrl + 'costcenters/CostCentersState', {
            observe: 'body',
            responseType: 'json',
            params: httpParams
        }).map(
            (response) => {
                return response;
            });
    }

    httpGetUserTerminals() {
      return this.httpClient.get<any[]>(this.appsettings.apiUrl + 'costcenters/GetUserTerminals', {
          observe: 'body',
          responseType: 'json'
      }).map(
          (response) => {
            return response;
          });
    }

    httpGetUnpaid(zoneIds: number[]) {
        let httpParams = new HttpParams();
        zoneIds.forEach(zoneId => {
          httpParams = httpParams.append('ZoneIds', zoneId.toString());
        });

        return this.httpClient.get<Unpaid[]>(this.appsettings.apiUrl + 'costcenters/Unpaid', {
            observe: 'body',
            responseType: 'json',
            params: httpParams
        }).map(
            (response) => {
                return response;
            });
    }

    httpGetCostCenterUnpaid(costCenterId: number) {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('CostCenterId', costCenterId.toString());

        return this.httpClient.get<UnpaidDetails>(this.appsettings.apiUrl + 'costcenters/CostCenterUnpaid', {
            observe: 'body',
            responseType: 'json',
            params: httpParams
        }).map(
            (response) => {
                return response;
            });
    }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/share/costCenter/costcenter.service.ts